export default __webpack_public_path__ + "static/media/image03.22fb4246.jpg";